import { NavLink } from "react-router-dom";

import geabLogo from "../../assets/styles/branding/geab-logo-2.svg";
import DeclarationModal from "../../components/electralink/DeclarationModal";
import useModal from "../../hooks/ModalHook";
import { TileConfig } from "../../pages/Dashboard/Dashboard.types";
import { useVisibleTiles } from "../../pages/Dashboard/useVisibleTiles";
import { signOutRedirect } from "../../utils/authUtils";
import Button from "../layout/Button";

import { buildNavRenderItems } from "./Navbar.constants";
import NavbarMenuGroup from "./NavbarMenuGroup";

const Navbar = () => {
  const { modalOpen, openModal, closeModal, proceedToDestination } = useModal();

  const visibleTiles = useVisibleTiles();
  const renderItems = buildNavRenderItems(visibleTiles);

  const renderTileLink = (tile: TileConfig) => (
    <NavLink
      key={tile.id}
      to={tile.path}
      className="navbar__menu-item"
      onClick={
        tile.requiresLoa
          ? (e) => {
              e.preventDefault();
              openModal(tile.path);
            }
          : undefined
      }
    >
      {tile.title}
    </NavLink>
  );

  return (
    <nav className="navbar">
      <div className="navbar__logo-container">
        <a href="/dashboard">
          <img src={geabLogo} alt="Logo" className="navbar__logo" />
        </a>
      </div>
      <div className="navbar__menu">
        <NavLink to="/dashboard" className="navbar__menu-item">
          Dashboard
        </NavLink>
        {renderItems.map((item) =>
          item.type === "group" ? (
            <NavbarMenuGroup key={item.group.id} title={item.group.title}>
              {item.tiles.map(renderTileLink)}
            </NavbarMenuGroup>
          ) : (
            renderTileLink(item.tile)
          ),
        )}
      </div>
      <div className="navbar__footer">
        <Button onClick={signOutRedirect}>Logout</Button>
      </div>
      <DeclarationModal
        key={modalOpen ? "open" : "closed"}
        isOpen={modalOpen}
        onClose={closeModal}
        onProceed={proceedToDestination}
      />
    </nav>
  );
};

export default Navbar;
